var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import Button from "../../atoms/button/button";
import { ButtonType } from "../../atoms/button/buttonType";
import DropDown from "../../atoms/dropDown/dropDown";
export default function GenericTab(props) {
    var _a = useState(0), current = _a[0], setCurrent = _a[1];
    return (_jsxs("div", __assign({ className: "flex flex-col md:flex-row justify-between w-full gap-4" }, { children: [_jsx("div", __assign({ className: "flex flex-wrap overflow-x-auto py-1 max-w-full" }, { children: props.titles.map(function (title, num) {
                    return (_jsx(Button, { onClick: function () {
                            if (props.titles.length != 1) {
                                props.setStateCallback(num);
                                setCurrent(num);
                            }
                        }, text: title, className: "whitespace-nowrap text-sm md:text-base px-3 ".concat(current === num ? "active font-medium" : ""), buttonType: ButtonType.Tertiary }, num));
                }) })), _jsx("div", __assign({ className: "flex justify-end items-center gap-2 ml-auto" }, { children: _jsx(DropDown, __assign({ id: "manageusers" }, { children: props.children })) }))] })));
}
